declare function gtag(...args: unknown[]): void;

export const trackWhatsAppConversion = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'conversion', {
      send_to: 'AW-17958749894/mQHjCPDIh_obEMaNs_NC',
      value: 1.0,
      currency: 'USD',
      transaction_id: '',
    });
  }
};
